<div class="breadcrumb-container container" *ngIf="!hideBreadcrumb">
  <p-breadcrumb [model]="items" [home]="home" />
</div>

<div class="perfil-layout-container container">

  <!-- PAGE HEADER -->
  <div class="page-header">
    <div>
      <h1 class="page-header-title">O Meu Perfil</h1>
      <p class="page-header-sub">Gere os teus dados de contacto, documentação e informação bancária</p>
    </div>
    <div class="page-header-actions">
      <button type="button" class="btn btn-primary" (click)="showEditDialog()">
        <i class="fas fa-edit"></i> Editar Informações
      </button>
    </div>
  </div>

  <div class="profile-layout">

    <!-- ═══ CARD LATERAL DE RESUMO ═══ -->
    <div class="profile-card">
      <div class="profile-card-hero">
        <div class="profile-card-avatar-wrap">
          <div class="profile-big-avatar">
            {{ getUserInitials() }}
          </div>
        </div>
      </div>
      <div class="profile-card-body">
        <div class="pc-name">{{ utilizador?.nomeCompleto || utilizador?.userName || 'Utilizador FundCube' }}</div>
        <div class="pc-since">Membro desde {{ utilizador?.dataCriacaoFormatada || '2024' }}</div>

        <div class="pc-stats">
          <div class="pc-stat">
            <div class="pc-stat-val">{{ utilizador?.tipoDocumento || 'BI' }}</div>
            <div class="pc-stat-lbl">Doc.</div>
          </div>
          <div class="pc-stat">
            <div class="pc-stat-val">{{ (saldoUser || utilizador?.saldo || 0) | money }}</div>
            <div class="pc-stat-lbl">Saldo Kz</div>
          </div>
          <div class="pc-stat">
            <div class="pc-stat-val text-green-600">Sim</div>
            <div class="pc-stat-lbl">Activo</div>
          </div>
        </div>

        <div class="pc-badges">
          <span class="pc-badge"><i class="fas fa-shield-alt"></i> Verificado</span>
          <span class="pc-badge"><i class="fas fa-star"></i> Apoiante Top</span>
          <span class="pc-badge" style="background:#eff6ff;color:var(--blue-500);border-color:#bfdbfe;">
            <i class="fas fa-heart"></i> Membro Activo
          </span>
        </div>
      </div>
    </div>

    <!-- ═══ FORMULÁRIO / DETALHES DE PERFIL ═══ -->
    <div class="profile-form-wrap">
      <div class="profile-form-card">

        <!-- 1. Informação Pessoal -->
        <div class="pfc-section">
          <div class="pfc-section-title">
            <i class="fas fa-id-card"></i> Informação Pessoal
          </div>

          <div class="form-group">
            <label class="form-label">Nome Completo</label>
            <div class="field-readonly">
              <i class="fas fa-user"></i>
              <span>{{ utilizador?.userName || utilizador?.nomeCompleto || 'Não informado' }}</span>
              <span class="field-readonly-lock"><i class="fas fa-lock"></i> Verificado</span>
            </div>
            <span class="form-hint">Para alterar o nome legal, contacte o suporte oficial da FundCube.</span>
          </div>

          <div class="form-group">
            <label class="form-label">NIF / Número de Identificação</label>
            <div class="field-readonly">
              <i class="fas fa-id-badge"></i>
              <span>{{ utilizador?.numeroDocumento || 'Não registado' }}</span>
              <span class="field-readonly-lock"><i class="fas fa-shield-check"></i> Seguro</span>
            </div>
          </div>

          <div class="form-group" style="margin-bottom:0;">
            <label class="form-label">Data de Nascimento</label>
            <div class="field-readonly">
              <i class="fas fa-calendar"></i>
              <span>{{ (utilizador?.dataNascimento | date: 'dd/MM/yyyy') || 'Não informada' }}</span>
            </div>
          </div>
        </div>

        <!-- 2. Dados de Contacto -->
        <div class="pfc-section">
          <div class="pfc-section-title">
            <i class="fas fa-phone-flip"></i> Dados de Contacto
            <span class="pfc-badge-edit">Editável</span>
          </div>

          <div class="form-group">
            <label class="form-label">Telefone</label>
            <div class="field-readonly">
              <i class="fas fa-phone"></i>
              <span>{{ utilizador?.telefone || 'Não informado' }}</span>
            </div>
            <span class="form-hint">Usado para receber notificações e confirmações por SMS.</span>
          </div>

          <div class="form-group" style="margin-bottom:0;">
            <label class="form-label">Email Principal</label>
            <div class="field-readonly">
              <i class="fas fa-envelope"></i>
              <span>{{ utilizador?.email || 'Não informado' }}</span>
            </div>
            <span class="form-hint">Usado para notificações de campanhas e comprovativos de doação.</span>
          </div>
        </div>

        <!-- 3. Dados Bancários -->
        <div class="pfc-section">
          <div class="pfc-section-title">
            <i class="fas fa-university"></i> Dados Bancários & Transferências
            <span class="pfc-badge-edit">Editável</span>
          </div>

          <div class="iban-info-box">
            <i class="fas fa-info-circle"></i>
            <p>
              O IBAN é utilizado para transferir os fundos das campanhas criadas em que é <strong>beneficiário</strong>.
              Certifique-se que pertence a uma conta bancária angolana activa com o seu nome.
              Prazo de liquidação: <strong>24–72 horas úteis</strong> após fecho da meta.
            </p>
          </div>

          <div class="form-group">
            <label class="form-label">IBAN Registado</label>
            <div class="field-readonly iban-field">
              <i class="fas fa-credit-card"></i>
              <span class="iban-val">{{ utilizador?.iban || 'AO06 0000 0000 0000 0000 0000 0' }}</span>
              <button type="button" class="btn-quick-edit" (click)="showEditDialog()">Actualizar</button>
            </div>
            <span class="form-hint">Formato bancário angolano normalizado (AO + 23 dígitos).</span>
          </div>

          <!-- CARTÃO BANCÁRIO VISUAL PREVIEW -->
          <div class="iban-preview-card" *ngIf="utilizador?.iban">
            <div class="ipc-glow"></div>
            <div class="ipc-header">
              <div class="ipc-bank-name"><i class="fas fa-university"></i> CONTA BANCÁRIA ANGOLANA</div>
              <div class="ipc-badge">AO</div>
            </div>
            <div class="ipc-chip"></div>
            <div class="ipc-iban">{{ utilizador?.iban }}</div>
            <div class="ipc-footer">
              <div>
                <div class="ipc-label">Titular da Conta</div>
                <div class="ipc-holder">{{ utilizador?.userName || utilizador?.nomeCompleto || 'Beneficiário' }}</div>
              </div>
              <div style="text-align: right;">
                <div class="ipc-label">Verificação</div>
                <div class="ipc-status"><i class="fas fa-circle-check"></i> FundCube.ao</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
          <button type="button" class="btn btn-outline" (click)="showEditDialog()">
            <i class="fas fa-pen-to-square"></i> Abrir Formulário de Edição
          </button>
        </div>
      </div>
    </div>

  </div>
</div>

<p-dialog [modal]="true" [(visible)]="showDialog"
  [style]="{ width: '94vw', 'max-width': '44rem', 'max-height': '94vh' }"
  [contentStyle]="{ 'max-height': 'calc(94vh - 65px)', 'overflow-y': 'auto' }" styleClass="dialog-editar-perfil"
  appendTo="body" header="Editar Informações do Perfil">
  <form [formGroup]="formPerfil" class="edit-profile-form">
    <div class="form-row-2">
      <div class="form-group">
        <label class="form-label" for="nacionalidade">Nacionalidade</label>
        <p-select formControlName="nacionalidade" [options]="nacional" [invalid]="isInvalid('nacionalidade')"
          optionLabel="label" optionValue="value" placeholder="Selecione uma Nacionalidade" appendTo="body"
          class="w-full"></p-select>
        <small class="field-error" *ngIf="isInvalid('nacionalidade')">
          <i class="fa-solid fa-triangle-exclamation"></i> Nacionalidade é obrigatória.
        </small>
      </div>

      <div class="form-group">
        <label class="form-label" for="tipoDocumentoENUM">Tipo de Documento</label>
        <p-select formControlName="tipoDocumentoENUM" [options]="tipoDocs" [invalid]="isInvalid('tipoDocumentoENUM')"
          optionLabel="label" optionValue="id" placeholder="Selecione o Documento" appendTo="body"
          class="w-full"></p-select>
        <small class="field-error" *ngIf="isInvalid('tipoDocumentoENUM')">
          <i class="fa-solid fa-triangle-exclamation"></i> Documento é obrigatório.
        </small>
      </div>
    </div>

    <div class="form-group">
      <label class="form-label" for="nif">NIF / Número de Documento</label>
      <div class="input-with-action">
        <input id="nif" type="text" pInputText formControlName="nif" class="form-input" />
        <button type="button" *ngIf="ShowBTN" class="btn-validate-nif" (click)="OnSerachNIF()"
          [disabled]="formPerfil.get('nif')?.disabled || loadingNif || !formPerfil.get('nif')?.value"
          [ngClass]="{ 'is-loading': loadingNif }" [attr.aria-busy]="loadingNif" title="Validar NIF">
          <i class="fa-solid" [ngClass]="loadingNif ? 'fa-spinner fa-spin' : 'fa-magnifying-glass'"></i>
          <span>{{ loadingNif ? 'A validar...' : 'Validar' }}</span>
        </button>
      </div>
      <small class="field-error" *ngIf="isInvalid('nif')">
        <i class="fa-solid fa-triangle-exclamation"></i> NIF é obrigatório e deve ser válido.
      </small>
    </div>

    <div class="form-row-2">
      <div class="form-group">
        <label class="form-label" for="userName">Nome Completo</label>
        <input id="userName" type="text" pInputText formControlName="userName" class="form-input" />
        <small class="field-error" *ngIf="isInvalid('userName')">
          <i class="fa-solid fa-triangle-exclamation"></i> Nome é obrigatório.
        </small>
      </div>

      <div class="form-group">
        <label class="form-label" for="email">E-mail</label>
        <input id="email" type="email" pInputText formControlName="email" class="form-input" />
        <small class="field-error" *ngIf="isInvalid('email')">
          <i class="fa-solid fa-triangle-exclamation"></i> Email deve ser válido.
        </small>
      </div>
    </div>

    <div class="form-row-2">
      <div class="form-group">
        <label class="form-label" for="telefone">Telefone</label>
        <input id="telefone" type="text" pInputText formControlName="telefone" class="form-input" />
        <small class="field-error" *ngIf="isInvalid('telefone')">
          <i class="fa-solid fa-triangle-exclamation"></i> Telefone é obrigatório.
        </small>
      </div>

      <div class="form-group">
        <label class="form-label" for="dataNascimento">Data de Nascimento</label>
        <p-datepicker formControlName="dataNascimento" [invalid]="isInvalid('dataNascimento')" appendTo="body"
          [minDate]="minDate" [maxDate]="maxDate" [defaultDate]="defaultDate" dateFormat="dd/mm/yy" [showIcon]="true"
          placeholder="dd/mm/aaaa" class="w-full"></p-datepicker>
        <small class="field-error" *ngIf="isInvalid('dataNascimento')">
          <i class="fa-solid fa-triangle-exclamation"></i>
          <span *ngIf="formPerfil.get('dataNascimento')?.errors?.['required']">Data de nascimento é obrigatória.</span>
          <span *ngIf="formPerfil.get('dataNascimento')?.errors?.['idadeInvalida']">Apenas permitido para pessoas entre 15 e 90 anos.</span>
          <span *ngIf="formPerfil.get('dataNascimento')?.errors?.['dataInvalida']">Data de nascimento inválida.</span>
        </small>
      </div>
    </div>

    <div class="form-group">
      <label class="form-label" for="iban">IBAN</label>
      <p-inputMask id="iban" formControlName="iban" mask="AO06 9999 9999 9999 9999 9999 9"
        placeholder="AO06 0000 0000 0000 0000 0000 0" class="w-full"></p-inputMask>
    </div>

    <div class="form-group">
      <label class="form-label" for="anonimo">Pretende exibir nome anónimo nas doações?</label>
      <p-select formControlName="anonimo" filter="true" placeholder="Seleccione" appendTo="body"
        [options]="typeUserOptions" optionLabel="label" optionValue="value" class="w-full"></p-select>
    </div>

    <div class="form-group" *ngIf="isAnonimoChecked">
      <label class="form-label" for="nomeUtilizador">Nome Anónimo de Exibição</label>
      <input id="nomeUtilizador" type="text" pInputText formControlName="nomeUtilizador" class="form-input"
        placeholder="Ex: Anjo Investidor" />
      <small class="field-error" *ngIf="isInvalid('nomeUtilizador')">
        <i class="fa-solid fa-triangle-exclamation"></i> Informe o nome anónimo a ser exibido.
      </small>
    </div>

    <div class="edit-dialog-actions">
      <button type="button" class="btn btn-ghost" (click)="closeEditDialog()">
        Cancelar
      </button>
      <button type="button" class="btn btn-primary" (click)="UpdatePerfil()">
        <i class="fa-solid fa-floppy-disk"></i> Guardar Alterações
      </button>
    </div>
  </form>
</p-dialog>

<p-confirmDialog></p-confirmDialog>